export default function FaqData() {
    return [
        {
            title: "Will my supplemental insurance premium payments ever go up?",
            text: ["Premiums for Aflac supplemental insurance policies (excluding Medicare Supplement policies) are guaranteed not to go up as long as premiums are paid according to policy specifications."]
        },
        {
            title: "Can the insurance company cancel my coverage if I get sick after my policy is issued?",
            text: ["No. Aflac will pay benefits as specified for a covered illness or injury that occurs while the policy is in force. "]
        },
        {
            title: "How much coverage should I apply for?",
            text: ["Expenses from a hospital stay can derail your life plans. When choosing a benefit amount, consider not only your expected hospital stay expenses, but your annual health insurance deductible. If you do not have a Health Savings Account, you may select from Aflac's optional riders to help with more costs. Remember, Aflac pays cash directly to you (unless otherwise assigned), so benefits can be used to help pay monthly expenses such as your mortgage and groceries."]
        },
        {
            title: "How can I pay for my insurance coverage?",
            text: ["You can pay your monthly premium via bank draft from a checking or savings account, or with a debit or credit card."]
        },
        {
            title: "What happens if I apply for this product and do not qualify?",
            text: ["Don't worry - Aflac has other options for coverage that may be better suited for you. Our team of insurance consultants can help you find coverage that works best for you."]
        }]
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Hospital/FaqData.js